/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IMedicine } from 'app/shared/model/medicine.model';
import { IIntraOPChart } from 'app/shared/model/intra-op-chart.model';
import { IPostOPRecoveryRecord } from 'app/shared/model/post-op-recovery-record.model';
import { IPreOpAnaesthesiaChart } from 'app/shared/model/pre-op-anaesthesia-chart.model';
import { OpMedicationType } from 'app/shared/model/enumerations/op-medication-type.model';

export interface IOpMedication {
  id?: string;
  type?: keyof typeof OpMedicationType | null;
  timeAdvised?: number | null;
  timeAdministered?: number | null;
  dose?: string | null;
  notes?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  drug?: IMedicine;
  intraOPChart?: IIntraOPChart;
  postOPRecoveryRecord?: IPostOPRecoveryRecord;
  preOpAnaesthesiaChart?: IPreOpAnaesthesiaChart | null;
}

export const defaultValue: Readonly<IOpMedication> = {
  active: false,
};
